import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsCategories(
  {
    page, size, direction, sort,
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-inspiration`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,

    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryInspiration(inspirationId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-inspiration/${inspirationId}`,
    method: 'get',
  });
}

export function _queryInspirationByGoodsId(
  // return fetch({
  //   url: `${process.env.VUE_APP_BASE_URL}/goods-inspiration/${goodsId}`,
  //   method: 'get',
  // });
  {
    page, size, direction, sort, goodsId
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-inspiration`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      goodsId
    },
  });
}

/**
 * 新增
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addInspiration(
  {
    goodsId,
    type,
    inspirationImg,
    inspirationVideo,
    videoCover,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-inspiration`,
    method: 'post',
    data: {
      goodsId,
      type,
      inspirationImg,
      inspirationVideo,
      videoCover,
    },
  });
}

/**
 * 更新
 * @param goodsCategoryId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateInspiration(inspirationId, {
  goodsId,
  type,
  inspirationImg,
  inspirationVideo,
  videoCover,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-inspiration/${inspirationId}`,
    method: 'patch',
    data: {
      goodsId,
      type,
      inspirationImg,
      inspirationVideo,
      videoCover,
    },
  });
}

/**
 * 删除
 * @param goodsCategoryId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteInspiration(inspirationId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-inspiration/${inspirationId}`,
    method: 'delete',
  });
}

export function _updateGoodsSort({ idStr, sortStr, oldIndex, newIndex
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website/inspiration/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}

export default {};
